import React from "react";
import Loaderr from "./Qubio-Spinner-Grey.json";
import Lottie from "lottie-react";
// style for loader

function Loader({ width }) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems:"center",
        backgroundColor:"white",
        padding:"5px 10px",
        borderRadius:"10px",
        width: `${width ?? "100px"}`,
      }}
    >
      <Lottie animationData={Loaderr} />
    </div>
  );
}

export default Loader;
